import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { getApiBase } from '../../lib/utils'

export default function WordPressPage() {
  const pluginDownloadHref = useMemo(() => {
    const base = getApiBase().replace(/\/$/, '')
    return `${base}/downloads/plugins/totemium/latest`
  }, [])

  return (
    <div className="relative overflow-hidden">
      <div aria-hidden className="absolute inset-0 -z-30 bg-gradient-to-b from-purple-50 via-white to-white dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-900" />
      <div aria-hidden className="absolute inset-x-0 top-0 -z-40 h-[320px] bg-[radial-gradient(circle_at_top,_rgba(168,85,247,0.25),_transparent_68%)]" />

      <div className="relative mx-auto max-w-[1600px] px-6 py-6">
        <div className="mb-6">
          <Link
            to="/integrations"
            className="inline-flex items-center gap-2 rounded-full border border-zinc-200/70 dark:border-zinc-800 bg-white/80 dark:bg-zinc-900/70 px-4 py-2 text-sm font-medium text-zinc-700 dark:text-zinc-300 shadow-sm transition hover:bg-zinc-50 dark:hover:bg-zinc-800"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
            Retour aux intégrations
          </Link>
        </div>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-zinc-900 dark:text-white">Plugin WordPress Totemium</h1>
          <p className="mt-2 text-zinc-600 dark:text-zinc-400">Installez le plugin officiel pour LearnDash</p>
        </div>

        <article className="relative overflow-hidden rounded-3xl border border-zinc-200/80 bg-white/95 p-6 shadow-md backdrop-blur dark:border-zinc-800/70 dark:bg-zinc-900/85">
          <div aria-hidden className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-purple-400/15 blur-3xl dark:bg-purple-500/20" />
          <div className="relative space-y-6">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <h2 className="text-lg font-semibold text-zinc-900 dark:text-white">Installation du plugin</h2>
                <p className="text-sm text-zinc-600 dark:text-zinc-300">Activez vos widgets en quelques minutes, sans code</p>
              </div>
              <a
                href={pluginDownloadHref}
                className="inline-flex items-center gap-2 rounded-full bg-purple-500 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white shadow-lg shadow-purple-500/40 transition hover:bg-purple-600"
                download="totemium-latest.zip"
              >
                Télécharger le plugin
              </a>
            </div>

            <div className="rounded-2xl border border-amber-300 bg-amber-100/60 px-4 py-3 text-amber-900 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-100">
              <h3 className="text-sm font-semibold uppercase tracking-wide">Pré-requis</h3>
              <ul className="mt-2 space-y-2 text-xs sm:text-sm">
                <li>• Accès administrateur WordPress</li>
                <li>• LearnDash activé pour relier vos formations</li>
                <li>• Clé API Totemium générée (voir <Link to="/integrations/api-key" className="underline hover:text-amber-700 dark:hover:text-amber-200">section Clé API</Link>)</li>
              </ul>
            </div>

            <div>
              <h3 className="mb-3 text-base font-semibold text-zinc-900 dark:text-white">Étapes d'installation</h3>
              <ol className="space-y-3 text-sm text-zinc-600 dark:text-zinc-300">
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-purple-500/15 text-xs font-semibold text-purple-600 dark:bg-purple-500/20 dark:text-purple-200">1</span>
                  <span>Installez le plugin depuis votre console WP ou téléversez l'archive fournie.</span>
                </li>
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-purple-500/15 text-xs font-semibold text-purple-600 dark:bg-purple-500/20 dark:text-purple-200">2</span>
                  <span>Renseignez l'URL API Totemium et votre clé API (générée dans la section Clé API).</span>
                </li>
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-purple-500/15 text-xs font-semibold text-purple-600 dark:bg-purple-500/20 dark:text-purple-200">3</span>
                  <span>Choisissez le sujet ou la formation Totemium à exposer.</span>
                </li>
                <li className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-purple-500/15 text-xs font-semibold text-purple-600 dark:bg-purple-500/20 dark:text-purple-200">4</span>
                  <span>Ajoutez le bloc Totemium ou les shortcodes <code className="rounded bg-zinc-100 px-1.5 py-0.5 text-xs dark:bg-zinc-800">[totemium_chat]</code> / <code className="rounded bg-zinc-100 px-1.5 py-0.5 text-xs dark:bg-zinc-800">[totemium_widget]</code> dans vos pages.</span>
                </li>
              </ol>
            </div>
          </div>
        </article>
      </div>
    </div>
  )
}
